import { fetchJson } from '@atlassian/jira-fetch';
import type { IssueId, IssueKey } from '@atlassian/jira-shared-types';
import type { AssociatedIssue } from '../common/types';

type ResponseIssue = {
	id: IssueId;
	key: IssueKey;
	fields: {
		summary: string;
		issuetype: {
			iconUrl: string;
		};
	};
};

const makeSearchBody = (ids: string[]): string =>
	JSON.stringify({
		jql: `id in (${ids.join(',')})`,
		// fields,
		startAt: 0,
		maxResults: 100,
		validateQuery: 'strict',
	});

const fetchBatch = (ids: string[]) =>
	fetchJson('/rest/api/3/search', {
		method: 'POST',
		body: makeSearchBody(ids),
	});

export const fetchAssociatedIssues = (
	associatedIssueIds: string[],
): Promise<Record<IssueId, AssociatedIssue>> =>
	associatedIssueIds.length === 0
		? Promise.resolve({})
		: fetchBatch(associatedIssueIds).then((result: { issues: ResponseIssue[] }) => {
				const associatedIssues: Record<IssueId, AssociatedIssue> = {};
				result.issues.forEach((issue) => {
					associatedIssues[issue.id] = {
						id: issue.id,
						key: issue.key,
						summary: issue.fields.summary,
						iconUrl: issue.fields.issuetype.iconUrl,
					};
				});
				return associatedIssues;
			});
